/**
 * Whether a one-line label ends in "…" because it does not fit its box (CU-869fmjzrg, menu ellipsis).
 * Pure and alias-free, so `node --test` runs it; `useTextCut` measures the real element with it.
 */
export function isTextCut(el) {
	if (!el) return false
	return el.scrollWidth > el.clientWidth
}
